module.exports = __webpack_public_path__ + "img/icon_wallet.85187720.svg";